import { useEffect } from "react";
import {
  applyAppleTouchIcon,
  applyDocumentTitle,
  applyFavicon,
  getDefaultDocumentTitle,
} from "../seo/documentHead";

/**
 * Apply page-level document title and optional favicon; restore on unmount.
 */
export function useDocumentHead({
  title,
  favicon,
  appleTouchIcon,
  enabled = true,
  restoreTitle = true,
  restoreFavicon = false,
} = {}) {
  useEffect(() => {
    if (!enabled || typeof document === "undefined") {
      return undefined;
    }

    const previousTitle = document.title;
    const previousFavicon = document.querySelector('link[rel="icon"]')?.href || null;
    const previousAppleIcon =
      document.querySelector('link[rel="apple-touch-icon"]')?.href || null;

    if (title) {
      applyDocumentTitle(title);
    }
    if (favicon) {
      applyFavicon(favicon, { id: "midpoint-page-favicon" });
    }
    if (appleTouchIcon) {
      applyAppleTouchIcon(appleTouchIcon, { id: "midpoint-page-apple-icon" });
    }

    return () => {
      if (restoreTitle) {
        applyDocumentTitle(previousTitle || getDefaultDocumentTitle());
      }
      if (restoreFavicon) {
        if (previousFavicon) {
          applyFavicon(previousFavicon, { id: "midpoint-page-favicon" });
        }
        if (previousAppleIcon) {
          applyAppleTouchIcon(previousAppleIcon, { id: "midpoint-page-apple-icon" });
        }
      }
    };
  }, [title, favicon, appleTouchIcon, enabled, restoreTitle, restoreFavicon]);
}
